<script>
export default {
  name: 'MeetingStatusBadge',
  props: {
    status: { type: String, required: true },
  },
}
</script>

<template>
  <span v-if="status === 'pending'" class="badge bg-warning text-dark">Ausstehend</span>
  <span v-else-if="status === 'accepted'" class="badge bg-success">Angenommen</span>
  <span v-else-if="status === 'declined'" class="badge bg-danger">Abgelehnt</span>
  <span v-else-if="status === 'canceled'" class="badge bg-secondary">Storniert</span>
</template>
